export default "__VITE_ASSET__CAu7ErEq__"